import { RefreshControl, View, VStack } from "@gluestack-ui/themed";
import { CreditTableHeader } from "./components/CreditTableHeader";

import { ProposalGroup } from "@repo/core/components/layout/ProposalGroup";

import { CreditTableSearchController } from "./controller";
import { ScrollView } from "@repo/core/components/layout/ScrollView";

import { ActionSheet } from "@repo/core/components/layout/Actionsheet";
import { Text } from "@repo/core/components/core/Text";
import { ProposalOptionsItem } from "@repo/core/screens/Proposals/screens/ProposalsSearch/components/ProposalOptionsSheet/ProposalOptionsItem";

import { CreditTableSearchLoading } from "./loading";
import { StatusBar } from "@repo/core/components/layout/StatusBar";

export function CreditTableSearch() {
  const {
    proposals,
    actionSheetRef,
    handleOnPressOption,
    handleOpenOptions,
    proposalOptions,
    isMobile,
    onRefresh,
    refreshing
  } = CreditTableSearchController();

  return (
    <>
      <StatusBar
        backgroundColor="$primary700"
        barStyle="light-content"
        showCustomStatusBar
      />
      <ScrollView
        flex={1}
        bgColor="$backgroundLight100"
        refreshControl={
          <RefreshControl
            bg="$primary700"
            refreshing={refreshing}
            onRefresh={onRefresh}
          />
        }
      >
        <View w="$full">
          <CreditTableHeader onRefresh={onRefresh} />
          <VStack p="$6" bgColor="$backgroundLight100">
            {!isMobile && refreshing ? (
              <CreditTableSearchLoading />
            ) : (
              <ProposalGroup
                items={proposals}
                onPressOption={handleOpenOptions}
              />
            )}
          </VStack>
        </View>
      </ScrollView>

      <ActionSheet ref={actionSheetRef}>
        <VStack w="$full" p="$2" mb="$2">
          <VStack mb="$4" px="$3">
            <Text fontSize="$md" fontWeight={500} color="$textLight600">
              Opções
            </Text>
          </VStack>

          <VStack>
            {proposalOptions?.map((option) => (
              <ProposalOptionsItem
                key={option.label}
                {...option}
                onPress={handleOnPressOption}
              />
            ))}
          </VStack>
        </VStack>
      </ActionSheet>
    </>
  );
}
